export const CL_ORDER_SEARCH_COLUMNS = [
    { value: 'firstName', label: 'First Name', icon: 'bi-person', theme: 'indigo' },
    { value: 'lastName', label: 'Last Name', icon: 'bi-person-badge', theme: 'purple' },
    { value: 'email', label: 'Email', icon: 'bi-envelope', theme: 'cyan' },
    { value: 'phoneNumber', label: 'Phone', icon: 'bi-telephone', theme: 'slate' },
    { value: 'brandName', label: 'Brand', icon: 'bi-tag', theme: 'violet' },
    { value: 'type', label: 'Fulfillment', icon: 'bi-box-seam', theme: 'warning' },
    { value: 'status', label: 'Status', icon: 'bi-flag', theme: 'success' },
    { value: 'quantity', label: 'Supply', icon: 'bi-calendar3', theme: 'danger' },
];

export const CL_ORDER_TYPE_OPTIONS = [
    { value: 'ALL', label: 'All fulfillment' },
    { value: 'PICKUP', label: 'Pickup' },
    { value: 'DELIVERY', label: 'Delivery' },
];

export const CL_ORDER_STATUS_OPTIONS = [
    { value: 'ALL', label: 'All statuses' },
    { value: 'PENDING', label: 'Pending' },
    { value: 'FULFILLED', label: 'Fulfilled' },
    { value: 'CANCELLED', label: 'Cancelled' },
];

export const CL_ORDER_STATUS_VALUES = [
    { value: 'PENDING', label: 'Pending' },
    { value: 'FULFILLED', label: 'Fulfilled' },
    { value: 'CANCELLED', label: 'Cancelled' },
];

export const CL_ORDER_SORT_FIELDS = [
    { value: 'createdAt', label: 'Created date' },
    { value: 'firstName', label: 'First name' },
    { value: 'lastName', label: 'Last name' },
    { value: 'type', label: 'Fulfillment' },
    { value: 'status', label: 'Status' },
    { value: 'quantity', label: 'Supply' },
];

export const CL_ORDER_PAGE_SIZE_OPTIONS = [10, 20, 50];

export const DEFAULT_CL_ORDER_SEARCH_COLUMN = 'firstName';

export const DEFAULT_CL_ORDER_FILTERS = {
    type: 'ALL',
    status: 'ALL',
};

export const DEFAULT_CL_ORDER_SORT = {
    sortBy: 'createdAt',
    sortOrder: 'DESC',
};

export const DEFAULT_CL_ORDER_PAGE_SIZE = 20;

export const formatClOrderCount = (value) => {
    const number = Number(value);

    if (!Number.isFinite(number)) {
        return '0';
    }

    return number.toLocaleString();
};

const EXACT_SEARCH_FIELDS = new Set(['type', 'status', 'quantity', 'patientId', 'brandId']);

const appendSearchFilter = (parts, field, value) => {
    const trimmed = value?.trim();
    if (!trimmed) {
        return;
    }

    if (EXACT_SEARCH_FIELDS.has(field)) {
        parts.push(`${field}==${trimmed}`);
        return;
    }

    parts.push(`${field}==*${trimmed}*`);
};

export const buildClOrderRequestsQuery = (
    {
        searchColumn = DEFAULT_CL_ORDER_SEARCH_COLUMN,
        searchTerm = '',
        showAll = false,
        type = DEFAULT_CL_ORDER_FILTERS.type,
        status = DEFAULT_CL_ORDER_FILTERS.status,
    } = {},
    sort = DEFAULT_CL_ORDER_SORT
) => {
    const parts = [];

    if (!showAll) {
        appendSearchFilter(parts, searchColumn, searchTerm);
    }

    if (type && type !== 'ALL') {
        parts.push(`type==${type}`);
    }

    if (status && status !== 'ALL') {
        parts.push(`status==${status}`);
    }

    if (sort?.sortBy) {
        parts.push(`sortBy==${sort.sortBy}`);
    }

    if (sort?.sortOrder) {
        parts.push(`sortOrder==${sort.sortOrder.toUpperCase()}`);
    }

    return parts.join(',');
};

export const formatClOrderPatientName = (order = {}) => {
    const fullName = [order.firstName, order.lastName].filter(Boolean).join(' ');
    return fullName || 'Unknown requester';
};

export const getClOrderTypeMeta = (type) => {
    switch (String(type || '').toUpperCase()) {
        case 'DELIVERY':
            return { label: 'Delivery', icon: 'bi-truck', className: 'optical-cl-order-type--delivery' };
        case 'PICKUP':
            return { label: 'Pickup', icon: 'bi-box-seam', className: 'optical-cl-order-type--pickup' };
        default:
            return { label: type || 'Order', icon: 'bi-question-circle', className: 'optical-cl-order-type--unknown' };
    }
};

export const getClOrderStatusMeta = (status) => {
    switch (String(status || '').toUpperCase()) {
        case 'PENDING':
            return {
                label: 'Pending',
                className: 'optical-cl-order-status--pending',
                icon: 'bi-hourglass-split',
            };
        case 'FULFILLED':
            return {
                label: 'Fulfilled',
                className: 'optical-cl-order-status--fulfilled',
                icon: 'bi-check-circle',
            };
        case 'CANCELLED':
            return {
                label: 'Cancelled',
                className: 'optical-cl-order-status--cancelled',
                icon: 'bi-x-circle',
            };
        default:
            return {
                label: status || 'Unknown',
                className: 'optical-cl-order-status--unknown',
                icon: 'bi-question-circle',
            };
    }
};

export const formatClOrderAddress = (order = {}) => {
    const line1 = [order.street, order.apt].filter(Boolean).join(', ');
    const line2 = [order.city, order.province, order.postalCode].filter(Boolean).join(', ');
    const parts = [line1, line2, order.country].filter(Boolean);
    return parts.length ? parts.join(' · ') : null;
};

export const formatClOrderDateTime = (value) => {
    if (!value) {
        return '—';
    }

    const date = new Date(value);
    if (Number.isNaN(date.getTime())) {
        return value;
    }

    return date.toLocaleString(undefined, {
        month: 'short',
        day: 'numeric',
        year: 'numeric',
        hour: 'numeric',
        minute: '2-digit',
    });
};
